import React, { memo, useContext, useEffect, useMemo, useRef } from 'react';
import { gql, useQuery } from '@apollo/client';
import Container from 'ls-common-client/src/components/Container';
import { Context } from '../../../context/AppContext';

const widgetMenuQuery = gql`
  query WidgetFragmentAppMenu(
    $variant: String!
    $appParameters: ParametersAppMenu
    $userParameters: ParametersUserMenu
  ) {
    widgetFragmentUserMenu(variant: $variant, parameters: $userParameters) {
      html
    }
    widgetFragmentAppMenu(variant: $variant, parameters: $appParameters) {
      html
    }
  }
`;

const SysMenus = ({ size = '34px', ...props }) => {
  const {
    user: { loading, user },
    auth,
  } = useContext(Context);

  const { data: widgetMenusData, loading: loadingMenu } = useQuery(
    widgetMenuQuery,
    {
      variables: {
        variant: 'day',
        appParameters: {
          size: '100%',
          colorActive1: '#97aeff',
          colorNormal1: 'white',
          colorActive2: '#2f393e',
          colorNormal2: '#2f393e',
        },
        userParameters: {
          size: '100%',
          dataLayerName: 'PageDataLayer',
          fullScreenZIndex: 2001,
          colorActive1: '#97aeff',
          colorNormal1: 'white',
          colorActive2: '#2f393e',
          colorNormal2: '#2f393e',
          skipGtmInjection: true,
        },
      },
    }
  );

  const { appMenuHtml, userMenuHtml } = useMemo(() => {
    const widgetFragmentAppMenu =
      widgetMenusData?.widgetFragmentAppMenu ?? null;
    const widgetFragmentUserMenu =
      widgetMenusData?.widgetFragmentUserMenu ?? null;

    return {
      userMenuHtml: widgetFragmentUserMenu?.html ?? '',
      appMenuHtml: widgetFragmentAppMenu?.html ?? '',
    };
  }, [widgetMenusData]);

  const intervalRef = useRef(0);

  useEffect(() => {
    if ((!userMenuHtml && !appMenuHtml) || loading) {
      return undefined;
    }
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(() => {
      if (window.lsWidget?.fragments) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        window.lsWidget.fragments.common.auth.setAuth({ auth, user });
      }
    }, 100);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [userMenuHtml, appMenuHtml, loading, user, auth]);

  return (
    <Container display="flex" alignItems="center" {...props}>
      {!loadingMenu && appMenuHtml && auth.token() && (
        <Container
          dangerouslySetInnerHTML={{ __html: appMenuHtml }}
          width={size}
          height={size}
          marginLeft="10px"
          transition="none"
        />
      )}
      {!loadingMenu && userMenuHtml && (
        <Container
          dangerouslySetInnerHTML={{ __html: userMenuHtml }}
          width={size}
          height={size}
          marginLeft="15px"
          transition="none"
          textAlign="left"
        />
      )}
    </Container>
  );
};

export default memo(SysMenus);
